import {Record} from "./Record";

export class NookalPatient extends Record
{
	id;
	firstName;
	lastName;
	dob;
	gender;
	email;
	phone;

	constructor(object)
	{
		super();
		this.setProperties(object);
	}
}

window.App = window.App || {};
window.App.Records = window.App.Records || {};
window.App.Records.NookalPatient = NookalPatient;
